import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import BlogInfoContent from '../components/BlogInfoContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';

class BlogInfo extends React.Component{

    constructor(){
        super();  
    }
 
    render()
    { 
        return (
            <div>
                <Header/> 
                <PageHeader title="Blogs" slug={this.props.params.id} />
                <BlogInfoContent slug={this.props.params.id}  />  
                <Footer/>
      
        
        </div>
       
        )
    }

}
export default withRouter(BlogInfo);;